import { STRATEGY_BENCHMARK_CHART_COLORS } from "./strategyBenchmarkChartColors";

function normalizePlot(plot) {
  if (!plot.length) {
    return [];
  }

  const baseValue = plot[0].value;

  return plot.map(point => ({
    time: point.time,
    value: point.value / baseValue - 1
  }));
}

function padStrategyPlotToComparisonStart(strategyPlot, comparisonPlot) {
  if (!strategyPlot.length || !comparisonPlot.length) {
    return strategyPlot;
  }

  const strategyStartTime = strategyPlot[0].time;
  const strategyStartValue = strategyPlot[0].value;
  const leadingComparisonPoints = comparisonPlot.filter(
    point => point.time < strategyStartTime
  );

  if (!leadingComparisonPoints.length) {
    return strategyPlot;
  }

  return [
    ...leadingComparisonPoints.map(point => ({
      time: point.time,
      value: strategyStartValue
    })),
    ...strategyPlot
  ];
}

export default function transformStrategyBenchmarkChartSeries(
  benchmarkData,
  comparisonType
) {
  const strategyPlot = benchmarkData?.strategy?.chart || [];
  const selectedComparison =
    benchmarkData?.comparisons?.find(item => item.key === comparisonType) ||
    benchmarkData?.comparisons?.[0];
  const comparisonPlot = selectedComparison?.chart || [];
  const paddedStrategyPlot = padStrategyPlotToComparisonStart(
    strategyPlot,
    comparisonPlot
  );

  return {
    strategyRateOfReturn: benchmarkData?.strategy?.rateOfReturn ?? 0,
    comparisonRateOfReturn: selectedComparison?.rateOfReturn ?? 0,
    chartSeries: [
      {
        id: "strategy",
        type: "area",
        color: STRATEGY_BENCHMARK_CHART_COLORS.strategy.line,
        topColor: STRATEGY_BENCHMARK_CHART_COLORS.strategy.top,
        bottomColor: STRATEGY_BENCHMARK_CHART_COLORS.strategy.bottom,
        data: normalizePlot(paddedStrategyPlot)
      },
      {
        id: "comparison",
        type: "line",
        color:
          STRATEGY_BENCHMARK_CHART_COLORS[selectedComparison?.key] ||
          STRATEGY_BENCHMARK_CHART_COLORS.wig20,
        data: normalizePlot(comparisonPlot)
      }
    ]
  };
}
